import * as React from "react";

import EditEscalatorEventLog from "../../Editing/EditEscalatorEventLog";
import Table from "../../../components/Table/Table";
import { editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";
import { setEscalatorEventLogExtraProperties } from "../../../utils/pdApiUtils";
import { Dimmer } from "semantic-ui-react";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import _ from "lodash";

/**
 * All the following props are passed from parent component
 */
export type EscalatorEventLogsTableProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  isLoadingEscalatorEventLogs: boolean;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  editActions: typeof editActions;
  pdApiActions: typeof pdApiActions;
  mainActions: typeof mainActions;
  toggleModal: () => void;
  subMenuRoute: State.EscalatorSubmenu;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.EscalatorSubmenu, columnFilter: Filter[]) => void;
};

type EscalatorEventLogsTableState = {
  isModalOpen: boolean;
};

export class EscalatorEventLogsTable extends React.Component<
  EscalatorEventLogsTableProps,
  EscalatorEventLogsTableState
> {
  state = {
    isModalOpen: false
  };

  componentDidMount(): void {//onload
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };
  
  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }
  render(): JSX.Element {
    const { columns, pdApi, mainState, isEditActive, toggleModal, isLoadingEscalatorEventLogs } = this.props;
    const { escalatorEventLogs } = pdApi;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    const escalatorEventLogRows: Api.EscalatorEventLog[] = escalatorEventLogs.map(row =>
      setEscalatorEventLogExtraProperties(row, pdApi)
    );
    let selectedColumns: State.Column[] = [];

    selectedColumns = columns["Event Logs"];
    const startingPage = mainState.lastEditedObjectId
      ? (escalatorEventLogRows.findIndex(escalatorEventLog => escalatorEventLog.id === mainState.lastEditedObjectId) / // tslint:disable-line: no-bitwise
          mainState.pageSize) >>
        0
      : 0;
    // Add submenu specific columns and rows
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            startingPage={startingPage}
            rows={escalatorEventLogRows}
            loading={isLoadingEscalatorEventLogs}
            loadingText="Fetching escalator event logs..."
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isEscalatorEventLogSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div className="edit-view" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
              <EditEscalatorEventLog toggleModal={toggleModal} columns={columns} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }

  private isEscalatorEventLogSelected = (escalatorEventLog: Api.EscalatorEventLog): boolean => {
    const editedObjectId = this.props.editedObjectId ?? this.props.mainState.lastEditedObjectId;
    if (editedObjectId && escalatorEventLog.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

export default EscalatorEventLogsTable;
